import { NativeDateAdapter } from "@angular/material/core";
import { ApplicationService } from "../services/application.service";

export class CustomDateAdapter extends NativeDateAdapter {
  private application: ApplicationService;

  public constructor(matDateLocale: string, application: ApplicationService) {
    super();
    this.application = application;
    this.locale = matDateLocale;
  }

  public override getFirstDayOfWeek(): number {
    return 1;
  }

  public override getDayOfWeekNames(style: "long" | "short" | "narrow"): string[] {
    return [...this.getLocaleDayNames(style, this.application.locale.value)];
  }

  public override getMonthNames(style: "long" | "short" | "narrow"): string[] {
    return [...this.getLocaleMonthNames(style, this.application.locale.value)];
  }

  public override format(date: Date, displayFormat: Record<string, unknown>): string {
    if (!this.isValid(date)) {
      throw Error("I18nDateAdapter: Cannot format invalid date.");
    }
    const dtf = new Intl.DateTimeFormat(this.application.locale.value, { ...displayFormat, timeZone: "utc" });
    return this.formatter(dtf, date);
  }

  private formatter(dtf: Intl.DateTimeFormat, date: Date): string {
    const d = new Date();
    d.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    d.setUTCHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return dtf.format(d);
  }

  private getLocaleMonthNames(format: "long" | "short" | "narrow", locale = this.locale) {
    return Array.from({ length: 12 }, (_, month) => new Intl.DateTimeFormat(locale, { month: format }).format(new Date(2000, month, 1)));
  }

  private getLocaleDayNames(format: "long" | "short" | "narrow", locale = this.locale) {
    const baseDate = new Date(2024, 0, 7);

    return Array.from({ length: 7 }, (_, day) =>
      new Intl.DateTimeFormat(locale, { weekday: format }).format(new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate() + day)),
    );
  }
}
